import React, { memo } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const QuestionContainer = ({ children }) => (
  <S.Container>{children}</S.Container>
);

export default memo(QuestionContainer);

QuestionContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
